import React from "react";
import profilelogo from "../../assets/photos/museumprofile.png";
import backgroundimage from "../../assets/photos/museumback.png";
import { connect } from "react-redux";

const VisitorHeader = (props) => {
  // visitor header component called from visitor
  return (
    <div className="userheader-page-layout">
      <div>
        <img src={backgroundimage} width="100%" height="363px"></img>
      </div>
      <div className="userheader-display">
        <div id="userheader-page-profile">
          <img src={profilelogo} width="161px" height="242px"></img>
        </div>
        <div className="userheader-museum-details">
          <p className="userheader-museum-name">
            {props.museum
              ? props.museum.name
                  .split(" ")
                  .splice(0, 3)
                  .join(" ")
              : "Sun Star Palace"}
            <br />
            {props.museum
              ? props.museum.name
                  .split(" ")
                  .splice(
                    3,
                    props.museum.name.length
                  )
                  .join(" ")
              : "Art Museum"}
          </p>
          <p className="userheader-museum-address">
            {props.museum
              ? props.museum.address.split(" ").splice(0, 3).join(" ")
              : "23782 Litzy Manor,"}
            <br />
            {props.museum
              ? props.museum.address
                  .split(" ")
                  .splice(3, props.museum.address.length)
                  .join(" ")
              : "Davonteville, AR 02213-4762"}
          </p>
        </div>
      </div>
      <hr></hr>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    museum: state.museumData.museumData,
  };
};

export default connect(mapStateToProps, null)(VisitorHeader);
